/*
This file is located in the main branch
Last time the file was updated (UTC): [06.12.2023 15:23:16]
Permissions to update outside the main branch: [false]
*/

import axios from 'axios';
import { stringify } from 'qs';

const publicUrl = process.env.PUBLIC_URL;
export const PAYLATER_API_URL = publicUrl + '/api';

export default axios.create({
    baseURL: PAYLATER_API_URL,
});

export const axiosPaylaterApi = axios.create({
    baseURL: PAYLATER_API_URL,
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true,
    paramsSerializer: (params) => {
        return stringify(params, {
            allowDots: true,
            skipNulls: true,
        });
    },
});
